
import { Component, Vue } from 'vue-property-decorator';
import HomeLayout from '@/component/layout/home.vue';
import { RouteTemplateType } from '@/common/enum';
import IndexLayout from '@/component/layout/index.vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
@Component({
  components: {
    HomeLayout,
    IndexLayout,
  },
})
export default class App extends Vue {
  locale: any = zhCN;
  routeTemplateType = RouteTemplateType;
  get layout(): string {
    const { meta } = this.$route;
    const { layout } = meta || {};
    return layout;
  }
}
